
import { useState, useEffect } from 'react'
import { lumi } from '../lib/lumi'
import toast from 'react-hot-toast'

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [hasShownWelcome, setHasShownWelcome] = useState(false)

  useEffect(() => {
    // 초기 상태 확인
    const checkInitialAuth = () => {
      const currentUser = lumi.auth.user
      const authenticated = lumi.auth.isAuthenticated
      
      setUser(currentUser)
      setIsAuthenticated(authenticated)
      setLoading(false)
      
      // 이미 로그인된 상태라면 환영 메시지 표시하지 않음
      if (authenticated && currentUser) {
        setHasShownWelcome(true)
        
        // 사용자 정보 자세히 로그 출력
        console.log('=== 사용자 정보 상세 ===')
        console.log('전체 사용자 객체:', currentUser)
        console.log('사용자 키들:', Object.keys(currentUser))
        console.log('userRole:', currentUser?.userRole)
        console.log('role:', currentUser?.role)
        console.log('권한들:', {
          userRole: currentUser?.userRole,
          role: currentUser?.role,
          isAdmin: currentUser?.isAdmin,
          admin: currentUser?.admin,
          permissions: currentUser?.permissions,
          accessLevel: currentUser?.accessLevel
        })
      }
    }

    checkInitialAuth()

    // 인증 상태 변경 리스너
    const unsubscribe = lumi.auth.onAuthChange((authUser) => {
      console.log('=== 인증 상태 변경 ===')
      console.log('사용자 정보:', authUser)
      
      if (authUser) {
        console.log('모든 사용자 속성:', Object.keys(authUser))
        console.log('권한 관련 필드들:', {
          userRole: authUser?.userRole,
          role: authUser?.role,
          isAdmin: authUser?.isAdmin,
          admin: authUser?.admin,
          permissions: authUser?.permissions,
          accessLevel: authUser?.accessLevel,
          email: authUser?.email,
          userName: authUser?.userName
        })
        
        setUser(authUser)
        setIsAuthenticated(true)
        
        // 환영 메시지를 한 번만 표시
        if (!hasShownWelcome) {
          toast.success(`환영합니다, ${authUser.userName || authUser.email}님!`)
          setHasShownWelcome(true)
        }
      } else {
        setUser(null)
        setIsAuthenticated(false)
        setHasShownWelcome(false)
      }
      setLoading(false)
    })

    return () => unsubscribe()
  }, [hasShownWelcome])

  const signIn = async () => {
    setLoading(true)
    try {
      console.log('로그인 시도 중...')
      await lumi.auth.signIn()
      // 상태는 onAuthChange에서 업데이트됨
    } catch (error) {
      console.error('로그인 실패:', error)
      toast.error('로그인에 실패했습니다.')
      setLoading(false)
    }
  }

  const signOut = async () => {
    try {
      console.log('로그아웃 중...')
      await lumi.auth.signOut()
      toast.success('로그아웃되었습니다.')
      setHasShownWelcome(false)
      // 상태는 onAuthChange에서 업데이트됨
    } catch (error) {
      console.error('로그아웃 실패:', error)
      toast.error('로그아웃에 실패했습니다.')
    }
  }

  // 관리자 권한 체크 - 데이터베이스 기반
  const [isAdmin, setIsAdmin] = useState(false)
  const [adminCheckLoading, setAdminCheckLoading] = useState(true)

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user?.email) {
        setIsAdmin(false)
        setAdminCheckLoading(false)
        return
      }

      try {
        // 데이터베이스에서 관리자 여부 확인
        const { list } = await lumi.entities.admin_users.list({
          filter: { 
            email: user.email,
            status: 'active'
          }
        })
        
        const isAdminUser = list && list.length > 0
        setIsAdmin(isAdminUser)
        
        console.log('=== 관리자 권한 확인 ===')
        console.log('사용자 이메일:', user.email)
        console.log('데이터베이스 조회 결과:', list)
        console.log('관리자 여부:', isAdminUser)
      } catch (error) {
        console.error('관리자 권한 확인 실패:', error)
        setIsAdmin(false)
      } finally {
        setAdminCheckLoading(false)
      }
    }

    checkAdminStatus()
  }, [user?.email])

  return { 
    user, 
    isAuthenticated, 
    loading: loading || adminCheckLoading, 
    signIn, 
    signOut,
    isAdmin
  }
}
